<template>
	<div class="app--engagement-sidebar" :class="classes" @click.self="close">
		<div class="navigation bg--sidebar">
			<div class="heading" v-if="theme.sidebar.image || theme.sidebar.info">
				<div v-if="theme.sidebar.image && info.logo" class="logo me-2">
					<img :src="info.logo">
				</div>
				<div class="info" v-if="theme.sidebar.info">
					<div class="title">{{info.name}}</div>
					<div class="description">
						<div>{{info.email}}</div>
						<div>{{info.phone}}</div>
					</div>
				</div>
			</div>
			<div class="pages">
				<a href="javascript:void(0);" v-for="(p, index) in panels" class="d-block"
					:class="{'active': page && p.id == page.id}" @click.prevent="go(p)">
					<span class="badge" v-if="p.type == 'START'"><app-icon value="bookmark"></app-icon></span>
					<span class="badge" v-if="p.type != 'START'">{{security == 'LOW' ? index+1 : index}}</span> 
					<span v-html="macro(p.title)"></span>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
	import store from '../store'
	export default {
		props: {
			pages: {type: Array, required: true }
		},
		computed: {
			theme()    { return store.state.theme },
			page()     { return store.state.page },
			active()   { return store.state.sidebar },
			security() { return store.state.security },
			info() {
				return {
					logo: store.state.info.company.logo,
					name: store.state.info.company.name,
					email: store.state.info.company.email,
					phone: store.state.info.company.phone,
				}
			},
			panels() { return this.pages.filter(p => p.type !== 'FINISH') },
			classes() { 
				let c = [
					'text--color-' + this.theme.sidebar.color,
					'text--font-'  + this.theme.sidebar.font,
					'text--size-'  + this.theme.sidebar.size,
				];
				if (this.active ) { c.push('active')   }
				if (this.closing) { c.push ('closing') }
				return c
			},
		},
		data() {
			return {closing: false}
		},
		methods: {
			macro(value) {
				return store.getters['macro'](value)
			},
			close() {
				this.closing = true
				setTimeout(() => {
					store.commit('SET_SIDEBAR', false) 
					this.closing = false
				}, 400)
			},
			go(page) {
				if (store.getters['validateEachPanel'] == true) {
					let parent = this.$parent
	                let element = null
	                if (parent && parent.$refs && parent.$refs[this.page.id] && parent.$refs[this.page.id].$el) {
	                    element = this.$validatePage(parent.$refs[this.page.id].$el)
	                    if (element === null) { 
	                		store.commit('SET_PAGE', page)
	                		this.$nextTick(() => { window.scrollTo(0,1) })
	                	} else {
	                		this.$nextTick(() => { element.scrollIntoView(false) })
	                	}
	                }
				} else {
					store.commit('SET_PAGE', page)
					this.$nextTick(() => { window.scrollTo(0,1) })
				}
				
				this.closing = false
				store.commit('SET_SIDEBAR', false)
			}
		}
	}
</script>
